import { render, staticRenderFns } from "./Bind.vue?vue&type=template&id=0e83cb0e&scoped=true&"
import script from "./Bind.vue?vue&type=script&lang=js&"
export * from "./Bind.vue?vue&type=script&lang=js&"
import style0 from "./Bind.vue?vue&type=style&index=0&id=0e83cb0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83cb0e",
  null
  
)

export default component.exports